module.exports = __webpack_public_path__ + "static/media/bubbles.1201af67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bubbles.png
// module id = 1437
// module chunks = 0